<template>
	<div class="content-pad-vert content-pad-horizontal">
		<v-layout row wrap class="pt-3">
			<v-flex xs12 lg10 offset-lg1>
				<div class="hidden-xs-only mt-5" style="margin-bottom: 50px; display: flex; flex-flow: row; justify-content: space-between;">
					<div class="dashboard__welcome-message">
						<div>
							<p class="dashboard__welcome-message__content--heading mb-3">
<!-- Welcome <b>{{ user.first_name || 'friend' }}!</b> -->
Hello <b>{{ user.first_name }}!</b>
							</p>
							<div v-if="shouldShowConfirmation" class="mb-2">
								<a
									class="mb-2 info--text"
									style="font-size: 0.8em; margin-bottom: 10px!important;"
									@click="setModalOpen({prop: 'registrationConfirmationModal', value: true})"
								>
									Complete Profile
								</a>
							</div>
							<div v-if="getAdminProp('welcomeMessage') !== null && getAdminProp('welcomeMessage') !== ''">
								<p class="dashboard__welcome-message__content" v-html="newlines(getAdminProp('welcomeMessage'))"></p>
							</div>
							<div v-else>
								<p class="dashboard__welcome-message__content">
									Good to see you.
								</p>
								<p class="dashboard__welcome-message__content mt-3">
									We'd love to hear your feedback about <b style="font-family: 'Quantico'">wrkprty.</b> If you think of anything, drop us a line at support@wrkprty.com
								</p>
								<p class="dashboard__welcome-message__content mt-3">
									Thanks!
								</p>
							</div>
						</div>
					</div>
					<div class="dashboard__host-tile dashboard__event-tile-flex elevation-3" id="dashboard--host-info-tile" @click="hostTileClick">
						<div class="hidden-xs-only dashboard__host-tile__green-rect-1 success"></div>
						<div class="hidden-xs-only dashboard__host-tile__blue-rect-2 info"></div>
						<div class="hidden-xs-only dashboard__host-tile__blue-rect-1 info"></div>
						<div style="display: flex; flex-direction: column; justify-content: center; height: 100%;" v-if="getHostTileState === 'nothost'">
							<div v-if="getHostTileState === 'nothost'" style="margin-bottom: 25px;">
								<p class="dashboard__host-tile-content mt-2">Turn your</p>
								<p class="dashboard__host-tile-content"><b style="font-size: 1.2em; margin-top: 5px!important;">living room</b></p>
								<p class="dashboard__host-tile-content">into the next <b style="font-size: 1.3em; font-family: 'Quantico'">wrkprty.</b></p>
								<p class="dashboard__host-tile-content mt-3"><b style="font-size: 0.9em; font-family: 'Quantico';">Become a Host.</b></p>
							</div>
							<div class="dashboard__host-tile__icon-container">
								<p class="dashboard__host-tile__icon-container__content">Share. Earn. Discover.</p>
								<img src="/static/images/color-white-host.svg" height="60px" width="60px">
							</div>
						</div>
						<div v-else-if="getHostTileState === 'hostrequest'" style="display: flex; flex-direction: column; justify-content: center; height: 100%;">
							<div v-if="getHostProcessStep !== 4">
								<p class="dashboard__host-tile-content2">Almost done!</p>
								<p class="dashboard__host-tile-content2">You're just a few steps away from becoming a <b style="font-size: 1.15em; font-family: 'Quantico'">wrkprty</b> host!</p>
								<p class="dashboard__host-tile-content2 info--text" style="width: 80%"><b>Continue host application</b></p>
							</div>
							<div v-else>
								<p class="dashboard__host-tile-content2 mb-4">Thank you for applying to become a <b style="font-size: 1.1em; font-family: 'Quantico'">wrkprty</b> host.</p>
								<p class="dashboard__host-tile-content2">You'll be hearing from us soon!</p>
							</div>
							<img style="position: absolute; bottom: 5px; right: 5px;" class="pb-2 pr-2" src="/static/images/color-white-host.svg" height="60px" width="60px">
						</div>
						<div v-else-if="getHostTileState === 'ishost'" style="display: flex; flex-direction: column; justify-content: center; height: 100%;">
							<div>
								<div style="display: flex; flex-direction: row; justify-content: space-between">
									
									<p class="dashboard__host-tile-content3 pr-0"><span style="font-size: 1.1em;">You're a Host!</span></p>
								</div>
								<p class="dashboard__host-tile-content3"><span style="font-size: 0.75em;">The Tools & Resources you need to create and manage amazing wrkprty events are here in your <b>Hosting Dashboard</b>. Need a hand? We're here to help!</span></p>
								<p class="dashboard__host-tile-content3 mb-4"><span style="font-size: 0.85em;"></span></p>
							</div>
							<img style="position: absolute; bottom: 5px; right: 5px;" class="pb-2 pr-2" src="/static/images/color-white-host.svg" height="60px" width="60px">
						</div>
					</div>
				</div>
				<v-layout row wrap class="mb-3">
					<v-flex xs12 class="hidden-sm-and-up">
						<div class="dashboard__welcome-message">
							<div>
							<!--	<p class="dashboard__welcome-message__content--heading">Welcome <b>{{ user.first_name || 'friend' }}!</b> -->
								<p class="dashboard__welcome-message__content--heading">Hello <b>{{ user.first_name }}!</b>
								</p>
								<div v-if="getAdminProp('welcomeMessage') !== null && getAdminProp('welcomeMessage') !== ''">
									<p class="dashboard__welcome-message__content" v-html="newlines(getAdminProp('welcomeMessage'))"></p>
								</div>
								<div v-else>
									<p class="dashboard__welcome-message__content">Good to see you.</p>
									<p class="dashboard__welcome-message__content mt-3">We'd love to hear your feedback about <b style="font-family: 'Quantico'">wrkprty.</b> If you think of anything, drop us a line at support@wrkprty.com</p>
									<p class="dashboard__welcome-message__content mt-3">Thanks!</p>
								</div>
							</div>
						</div>
					</v-flex>
				</v-layout>
				<v-layout row wrap>
					<v-flex xs12 class="mb-2">
						<div class="dashboard__event-list-header-container">


							<div class="dashboard__event-list-header"><div class="event-search__filters">UPCOMING NEAR YOU</div></div> 

					<!-- old style		<div class="dashboard__event-list-header"><div class="mb-0">UPCOMING NEAR YOU</div></div> -->
							<v-btn flat class="dashboard__event-list-header-more-button" @click="$router.push({name: 'events'})">See all <v-icon small class="pl-2">fal fa-chevron-right</v-icon></v-btn>
						</div>
					</v-flex>
				</v-layout>
				<v-layout v-if="getEventsLoaded" row wrap class="mb-1 hidden-xs-only">
					<div style="width: 100%; display: flex; flex-flow: row wrap; justify-content: space-between;" id="upcoming-events-container">
						<div class="dashboard__event-tile-flex" v-for="event in getAllEvents.slice(0,9)" :key="event.pk">
							<event-list-item :event="event" v-if="event.pk"></event-list-item>
						</div>
					</div>
				</v-layout>

				<v-layout v-if="getEventsLoaded" row wrap class="hidden-sm-and-up">
					<v-flex d-flex xs12 sm6 md4 class="mb-5" v-for="event in getAllEvents.slice(0,12)" :key="event.pk + '-2'">
						<event-list-item :event="event"></event-list-item>
					</v-flex>
				</v-layout>
				<v-layout v-else row wrap class="mb-1">
					<v-flex xs12 class="text-xs-center mb-5 mt-5">
						<v-progress-circular indeterminate size="100" color="grey darken-5"></v-progress-circular>
					</v-flex>
				</v-layout>

				<div style="width: 100%;" class="text-xs-center">
					<v-btn large flat class="hidden-xs-only dashboard__event-list-header-more-button--bottom" @click="$router.push({name: 'events'})">See all events<v-icon small class="pl-2">fal fa-chevron-right</v-icon></v-btn>
					<v-btn large flat block class="mb-5 hidden-sm-and-up dashboard__event-list-header-more-button--bottom" @click="$router.push({name: 'events'})"><u>See all events</u><v-icon small class="pl-2">fal fa-chevron-right</v-icon></v-btn>
				</div>
				<div class="dashboard__host-tile dashboard__event-tile-flex elevation-3 mb-5 hidden-sm-and-up" @click="hostTileClick">
					<div style="display: flex; flex-direction: column; justify-content: center; height: 100%;" v-if="getHostTileState === 'nothost'">
						<div v-if="getHostTileState === 'nothost'" style="padding-bottom: 10%;">
							<p class="dashboard__host-tile-content mt-2">Turn your</p>
							<p class="dashboard__host-tile-content"><b style="font-size: 1.2em; margin-top: 5px!important;">living room</b></p>
							<p class="dashboard__host-tile-content">into the next <b style="font-size: 1.3em; font-family: 'Quantico'">wrkprty.</b></p>
							<p class="dashboard__host-tile-content mt-3"><b style="font-size: 0.9em; font-family: 'Quantico';">Become a Host.</b></p>
						</div>
						<div class="dashboard__host-tile__icon-container">
							<p class="dashboard__host-tile__icon-container__content">Share. Earn. Discover.</p>
							<img src="/static/images/color-white-host.svg" height="60px" width="60px">
						</div>
					</div>
					<div v-else-if="getHostTileState === 'hostrequest'" style="display: flex; flex-direction: column; justify-content: center; height: 100%;">
						<div v-if="getHostProcessStep !== 4">
							<p class="dashboard__host-tile-content2">Almost done!</p>
							<p class="dashboard__host-tile-content2">You're just a few steps away from becoming a <b style="font-size: 1.15em; font-family: 'Quantico'">wrkprty</b> host!</p>
							<p class="dashboard__host-tile-content2 info--text" style="width: 80%"><b>Continue host application</b></p>
						</div>
						<div v-else>
							<p class="dashboard__host-tile-content2 mb-4">Thank you for applying to become a <b style="font-size: 1.1em; font-family: 'Quantico'">wrkprty</b> host.</p>
							<p class="dashboard__host-tile-content2">You'll be hearing from us soon!</p>
						</div>
						<img style="position: absolute; bottom: 5px; right: 5px;" class="pb-2 pr-2" src="/static/images/color-white-host.svg" height="60px" width="60px">
					</div>
					<div v-else-if="getHostTileState === 'ishost'" style="display: flex; flex-direction: column; justify-content: center; height: 100%;">
						<div>
							<div style="display: flex; flex-direction: row; justify-content: space-between">
								<p class="dashboard__host-tile-content3 pr-0"><span style="font-size: 1.1em;">Host application approved!</span></p>
							</div>
							<p class="dashboard__host-tile-content3"><span style="font-size: 0.75em;">Congratulations!</span></p>
							<p class="dashboard__host-tile-content3 mb-4"><span style="font-size: 0.75em;">Go to the <b class="info--text">host dashboard</b> to create and manage your own <b style="font-size: 1.1em; font-family: 'Quantico'">wrkprty</b> events.</span></p>
						</div>
					</div>
				</div>
			</v-flex>
		</v-layout>
	</div>
</template>

<script>
import moment from 'moment'
import axios from 'axios'

import { mapGetters, mapActions } from 'vuex'
import {
	fetchAllEvents,
	fetchNearbyEvents
} from '~/store/api/event_location_api'

import { replaceNewlines } from '~/store/util/util'

import * as TYPE from '~/store/util/types'

import EventListItem from '~/components/EventListItem.vue'

export default {
	name: 'dashboard',
	created() {
		document.body.style.backgroundColor = "#f5f5f5";
		},	
	created() {
		fetchAllEvents().then((response) => {
			this.setAllEvents(response.data)
			this.setEventsLoaded(true)
		}).catch((error) => {
			console.error(error)
		})
		this.setMobileNavActive('root')
	},
	methods: {
		...mapActions([
			'setEventsLoaded',
			'setMobileNavActive',
			'setAllEvents',
			'fetchNearbyEvents',
			'setEventFilter',
			'setModalOpen'
		]),
		newlines(value) {
			return replaceNewlines(value)
		},
		goToCurrentStep() {
			if (this.getHostProcessStep === 1) {
				this.$router.push('/host/apply')
			} else if (this.getHostProcessStep === 2) {
				this.$router.push('/host/apply/space')
			} else if (this.getHostProcessStep === 3) {
				this.$router.push('/host/add/location')
			}
		},
		hostTileClick() {
			if (this.getHostTileState === 'nothost') {
				this.$router.push({ name: 'host_info' })
			} else if (this.getHostTileState === 'hostrequest') {
				this.goToCurrentStep()
			} else if (this.getHostTileState === 'ishost') {
				this.$router.push({ name: 'host_dashboard' })
			}
		}
	},
	computed: {
		...mapGetters([
			'user',
			'getHost',
			'getEventsLoaded',
			'getAllEvents',
			'userIsHost',
			'userHasHostRequest',
			'getHostProcessStep',
			'getAdminProp'
		]),
		getHostTileState() {
			if (this.userHasHostRequest) {
				return 'hostrequest'
			} else if (!this.userIsHost) {
				return 'nothost'
			} else {
				return 'ishost'
			}
		},
		shouldShowConfirmation () {
			// return true
			return (
				!this.user.bio ||
				!this.user.interests ||
				!this.user.gender ||
				!this.user.where_from ||
				!this.user.password_set
			)
		}
	},
	components: {
		EventListItem
	}
}
</script>

<style lang="scss" scoped>
.dashboard-filters {
	background-color: #fafafa;
	position: fixed;
	width: 100%;
	z-index: 2;
	border-bottom: 1px solid lightgray;
}

.constrain {
	width: 480px;
	margin: 0 auto;
	padding: 1rem;
}

.dashboard__event-list-header-container {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
}

.dashboard__event-list-header {
	display: flex;
	flex-flow: row wrap;
	justify-content: flex-start;
	align-items: baseline;
	font-size: 1.1em;
	font-family: 'Quantico';
	color: #777;
}

.dashboard__event-list-header-more-button {
	font-family: 'Quantico';
	color: #777 !important;
	font-size: 1.1em !important;
	width: 80px !important;
	min-width: 80px !important;
	margin: 0px 0 0px 0px !important;
	padding: 0 !important;
}

.dashboard__event-list-header-more-button--bottom {
	font-family: 'Quantico';
	font-size: 1.1em;
	height: 65px !important;
	width: 30%;
	background-color: #e2e2e2;
	color: #666 !important;
	margin-top: 40px;
}

.dashboard__host-tile {
	font-size: 1.15em;
	position: relative;
	cursor: pointer;
	background-image: url('//wrkprty.imgix.net/backgrounds/host-info-girl-computer.jpg?q=65&exp=-10&w=400');
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
}

.dashboard__host-tile-flex {
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	height: 100%;
}

.dashboard__host-tile__icon {
	height: 20px;
	width: 20px;
	background-image: url('/static/images/color-white-host.svg');
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
}

.dashboard__host-tile-content {
	line-height: 1.5em;
	font-size: 1em;
	margin-bottom: 1px;
	color: #FFF;
	margin-left: 30px;
	padding-right: 10px;
}

.dashboard__host-tile-content2 {
	line-height: 1.25em;
	font-size: 0.9em;
	margin-bottom: 10px;
	color: #FFF;
	margin-left: 20px;
	padding-right: 20px;
}

.dashboard__host-tile-content3 {
	line-height: 1em;
	font-size: 1em;
	color: #FFF;
	margin-left: 20px;
	padding-right: 20px;
}

.dashboard__host-tile__icon-container {
	position: absolute;
	bottom: 0;
	right: 0;
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	margin-right: 10px;
	margin-bottom: 8px;
}

.dashboard__host-tile__icon-container__content {
	margin-bottom: 0px;
	line-height: 1.5em;
	font-size: 0.9em;
	font-weight: bold;
	color: #fafafa;
	font-family: 'Quantico';
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
}

.dashboard__host-tile__padding {
	padding: 0px 0px 0px 0px;
}

.dashboard__host-tile__blue-rect-1 {
	position: absolute;
	bottom: -15px;
	left: -15px;
	width: 150px;
	height: 12px;
	pointer-events: none !important;
}

.dashboard__host-tile__blue-rect-2 {
	position: absolute;
	bottom: -15px;
	left: -15px;
	height: 50px;
	width: 12px;
	pointer-events: none !important;
}

.dashboard__host-tile__green-rect-1 {
	position: absolute;
	bottom: -15px;
	left: -15px;
	height: 150px;
	width: 12px;
	pointer-events: none !important;
}

.dashboard__welcome-message {
	display: flex;
	flex-direction: column;
	justify-content: center;
	min-height: 350px;
	width: 65%;
	line-height: 1.2em;
	font-size: 1.3em;
	padding-right: 5%;
	flex-shrink: 1;
}

.dashboard__welcome-message__content {
	margin-bottom: 0px;
	color: #777;
	font-size: 0.8em;
	&--heading {
		color: #777;
		font-size: 1.5em;
		font-family: 'Quantico';
	}
}

.dashboard__event-tile-flex {
	width: 30%;
	height: 350px;
	margin-bottom: 60px;
}

/* lg */
@media screen and (max-width: 1920px) {
	.dashboard__event-tile-flex {
		height: 300px;
	}
	.dashboard__welcome-message {
		min-height: 300px;
	}
}

/* md */
@media screen and (max-width: 1280px) {
	.dashboard__event-tile-flex {
		height: 250px;
	}
	.dashboard__welcome-message {
		min-height: 250px;
	}
}

/* sm */
@media screen and (max-width: 960px) {
	.dashboard__event-list-header-more-button--bottom {
		width: 100%;
	}
	.dashboard__event-tile-flex {
		height: 300px;
		width: 48%;
	}
	.dashboard__welcome-message {
		min-height: 300px;
		padding-right: 2%;
		width: 48%;
	}
}

/* xs */
@media screen and (max-width: 599px) {
	.dashboard__host-tile {
		font-size: 1.2em;
	}
	.dashboard__event-list-header-more-button--bottom {
		width: 100%;
	}
	.dashboard__event-tile-flex {
		width: 100%;
		height: 300px;
	}
	.dashboard__welcome-message {
		min-height: 250px;
		width: 100%;
		padding-top: 20px;
		padding-right: 0;
		margin-left: 0;
		padding-bottom: 40px;
	}
	.dashboard__event-list-header-more-button {
		margin-right: 0px !important;
		margin-left: 0px !important;
	}
}
</style>
